'use client';

import { useState } from "react";
import AppBarBar from "../components/AppBar";
import FooterPage from "../components/FooterPage";
import SuccessDialog from "../components/success-dialog";
import { ref, set } from "firebase/database";
import database from "../firebase";

function ContactForm() {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        message: ''
    });
    const [dialogOpen, setDialogOpen] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value
        }));
    };

    const sendMessage = async (e) => {
        e.preventDefault();
    
        const messageId = generateRandomId();
        const messageRef = ref(database, `Messages/${messageId}`);
    
        try {
            await set(messageRef, {
                name: formData.name,
                phone: formData.phone,
                email: formData.email,
                message: formData.message,
                timestamp: Date.now()
            });
            setDialogOpen(true);
            setFormData({ name: '', phone: '', email: '', message: '' }); 
            console.log("insins");
            
        } catch (error) {
            console.error('Error sending message:', error);
        }
    };

    function generateRandomId() {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        const charactersLength = characters.length;
    
        for (let i = 0; i < 10; i++) {
            const randomIndex = Math.floor(Math.random() * charactersLength);
            result += characters.charAt(randomIndex);
        }
        return result;
    }

    const handleCloseDialog = () => {
        setDialogOpen(false); 
    };

    return (
        <div className="bg-canvas min-h-screen flex flex-col justify-between">
            <div>
                {/* Navigation */}
                <AppBarBar />

                {/* Header Section */}
                <div className="bg-forest text-canvas pt-32 pb-16 sm:pt-40 sm:pb-20">
                    <div className="max-w-6xl mx-auto px-6 sm:px-8">
                        <p className="text-grain font-semibold text-xs uppercase tracking-[0.2em] mb-3">
                            Get In Touch
                        </p>
                        <h1 className="font-display text-4xl sm:text-5xl mb-4">
                            Contact Us
                        </h1>
                        <p className="text-canvas/70 max-w-lg">
                            Have questions about our initiatives or pulse crop campaigns? We'd love to hear from you.
                        </p>
                    </div>
                </div>

                {/* Form Container */}
                <div className="max-w-xl mx-auto px-6 sm:px-8 py-16">
                    <form 
                        onSubmit={sendMessage} 
                        className="flex flex-col gap-6 bg-white/40 p-8 rounded-2xl border border-forest/15 shadow-md"
                    >
                        <div>
                            <label htmlFor="name" className="block text-sm font-semibold text-ink mb-2">
                                Name <span className="text-forest">*</span>
                            </label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                required
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Your full name"
                                className="w-full rounded-full border border-forest/20 px-4 py-2.5 text-sm focus:outline-none focus:border-forest bg-canvas/30 text-ink placeholder-ink/40 transition-colors"
                            />
                        </div>

                        <div>
                            <label htmlFor="phone" className="block text-sm font-semibold text-ink mb-2">
                                Phone Number <span className="text-ink/40 font-normal">(Optional)</span>
                            </label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                placeholder="Your contact number"
                                className="w-full rounded-full border border-forest/20 px-4 py-2.5 text-sm focus:outline-none focus:border-forest bg-canvas/30 text-ink placeholder-ink/40 transition-colors"
                            />
                        </div>

                        <div>
                            <label htmlFor="email" className="block text-sm font-semibold text-ink mb-2">
                                Email Address <span className="text-forest">*</span>
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                required
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="your.email@example.com"
                                className="w-full rounded-full border border-forest/20 px-4 py-2.5 text-sm focus:outline-none focus:border-forest bg-canvas/30 text-ink placeholder-ink/40 transition-colors"
                            />
                        </div>

                        <div>
                            <label htmlFor="message" className="block text-sm font-semibold text-ink mb-2">
                                Message <span className="text-forest">*</span>
                            </label>
                            <textarea
                                id="message"
                                name="message"
                                required
                                rows={4}
                                value={formData.message}
                                onChange={handleChange}
                                placeholder="How can we help you?"
                                className="w-full rounded-2xl border border-forest/20 px-4 py-2.5 text-sm focus:outline-none focus:border-forest bg-canvas/30 text-ink placeholder-ink/40 resize-none transition-colors"
                            />
                        </div>

                        <button
                            type="submit"
                            className="w-full bg-[#269926] hover:bg-forest text-canvas font-semibold py-3 px-6 rounded-full transition-all shadow-md mt-2"
                        >
                            Submit Message
                        </button>
                    </form>
                </div>
            </div>

            {/* Footer without repetitive newsletters */}
            <FooterPage preFooter={false} />

            <SuccessDialog 
                open={dialogOpen} 
                onClose={handleCloseDialog} 
                message="We have received your message and we'll get back to you soon." 
            />
        </div>
    );
}

export default ContactForm;